import { WhatsAppSendLimit } from 'modules/graphql/types/GraphQLEspAccount';
import { WHATSAPP_SEND_LIMIT_DISPLAY_MAPPING } from 'modules/sendingPlatforms/constants/text';
import { WhatsAppLocaleContent } from 'modules/templateEditor/common/types';
import { BADGE_VARIANTS } from 'ui/badge';
import { ErrorFill16 } from 'ui/icons/aurora/16px/ErrorFill16';
import { HelpTooltip } from 'ui/tooltip';
import { InvertedErrorBadge, Wrapper } from './styles';

const BADGE_TEXT = 'Send limit reached';

export const getTooltipText = (limitedSenders: WhatsAppLocaleContent[]) => {
  const limit = limitedSenders[0].whatsAppSender?.sendLimit || WhatsAppSendLimit.LimitNa;
  const friendlyNumberLimit = WHATSAPP_SEND_LIMIT_DISPLAY_MAPPING[limit]?.friendlyNumber;

  return limitedSenders.length > 1
    ? `Limit reached for multiple senders. New messages will be skipped, but replies to ongoing conversations are allowed. New conversation ability will gradually restore.`
    : `Limit reached ${friendlyNumberLimit ? `(${friendlyNumberLimit} new conversations in 24 hours)` : ``}. New messages will be skipped, but replies to ongoing conversations are allowed. New conversation ability will gradually restore.`;
};

type WhatsAppSenderLimitedBadgeProps = {
  limitedSenders: WhatsAppLocaleContent[];
};

export const SENDER_LIMITED_BADGE_TEST_ID = 'sender-issues-badge';

export const WhatsAppSenderLimitedBadge = ({ limitedSenders }: WhatsAppSenderLimitedBadgeProps) => {
  const tooltipText = getTooltipText(limitedSenders);

  return (
    <InvertedErrorBadge
      data-test={SENDER_LIMITED_BADGE_TEST_ID}
      icon={<ErrorFill16 />}
      variant={BADGE_VARIANTS.INVERTED}
    >
      <Wrapper>
        <span>{BADGE_TEXT}</span>
        <HelpTooltip
          automaticallyAvoidCollisions
          iconProps={{ height: 16, width: 16, isColorInherited: true }}
          tooltipContent={tooltipText}
        />
      </Wrapper>
    </InvertedErrorBadge>
  );
};
